import React from 'react';
import { Card, CardContent } from '@/Components/ui/card';
import { Badge } from '@/Components/ui/badge';
import { Stack } from '@/Components/ui/layout';
import { Inline } from '@/Components/ui/layout';
import { Heading } from '@/Components/ui/typography';
import { Text } from '@/Components/ui/typography';
import { cn } from '@/lib/utils';

export const CompanyCard = () => {
  return (
    <Card className={cn(
      "bg-[#e0e0e0] border border-white/10 rounded-[20px] transition-all cursor-pointer",
      "hover:-translate-y-1 hover:border-primary/30 hover:shadow-lg",
      "relative overflow-hidden w-full max-w-[400px] mx-auto",
      "before:content-[''] before:absolute before:top-0 before:left-0 before:right-0",
      "before:h-1 before:bg-gradient-to-r before:from-primary before:via-[#50c598] before:to-primary",
      "before:opacity-0 before:transition-opacity hover:before:opacity-100"
    )}>
      <CardContent className="p-6">
        <Stack spacing="lg">
          <Inline spacing="lg" align="center" className="mb-6">
            <div className={cn(
              "w-16 h-16 rounded-xl bg-gradient-to-br from-primary/10 to-[#50c598]/10",
              "border border-primary/20 transition-transform",
              "group-hover:scale-105"
            )} />
            <Stack spacing="xs" className="flex-1">
              <Heading level="h3" className="text-[22px] font-semibold text-[#2a2a2a] mb-2">
                Company Name
              </Heading>
              <Badge variant="default" className="w-fit">
                Hiring
              </Badge>
            </Stack>
          </Inline>
          
          <Stack spacing="md" className="mt-5">
            <Inline spacing="sm" className="gap-2.5">
              <Card className="bg-white/3 p-4 rounded-xl transition-transform hover:-translate-y-0.5 hover:bg-primary/10">
                <Stack spacing="xs">
                  <Text size="sm" className="text-[#2a2a2a]">Open Jobs</Text>
                  <Inline spacing="sm" align="center">
                    <Text size="lg" className="font-semibold text-[#2a2a2a]">250</Text>
                    <img 
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/bf103141c18b58998a0c9b12c1c84091bda6c35e41e88a00979bb6a7af9c41df?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803" 
                      alt="" 
                      loading="lazy" 
                      className="w-4 h-4"
                    />
                  </Inline>
                </Stack>
              </Card>
              <Card className="bg-white/3 p-4 rounded-xl transition-transform hover:-translate-y-0.5 hover:bg-primary/10">
                <Stack spacing="xs">
                  <Text size="sm" className="text-[#2a2a2a]">Employees</Text>
                  <Text size="lg" className="font-semibold text-[#2a2a2a]">250</Text>
                </Stack>
              </Card>
            </Inline>
            
            <Card className="bg-white/3 p-4 rounded-xl mt-[120px]">
              <Stack spacing="sm">
                <Text size="sm" className="text-[#2a2a2a]">Layoffs (Past 2Yr)</Text>
                <Stack spacing="xs">
                  <Text size="base" className="text-[#2a2a2a]">28,000 people</Text>
                  <Text size="base" className="text-[#2a2a2a]">25 layoff events</Text>
                </Stack>
              </Stack>
            </Card>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};
